module.exports = __webpack_public_path__ + "8954a3ffb4b64d78ccf4d3e0ce597b57.svg";